import React, { ReactNode } from "react"
import { useTranslation } from "react-i18next";

//MUI
import { IconButton, Button, Box, ButtonBase } from "@mui/material";
import { ArrowLeft, ArrowRight } from '@mui/icons-material';
import { useTheme } from "@mui/material";

type ClosePaneButtonProps = {
  open: boolean;
  pane: number | undefined;
  handleToggleHidePane: (state: boolean) => void;
}

const ClosePaneButton = (props: ClosePaneButtonProps) => {

  const { open, pane, handleToggleHidePane } = props;

  const theme = useTheme();
  const mainColor = theme.palette.primary.main;

  const { t } = useTranslation();

  const handleClick = (event: React.MouseEvent<HTMLElement>) =>{
    handleToggleHidePane(open ? false : true);
  }

  return (
      <Button
        disableFocusRipple
        onClick={handleClick}
        sx={{
          display: {xs: "none", lg: "flex"},
          pading:0,
          position: "absolute",
          left: open? "400px" : "-24px",
          top: "calc( 50% - 24px )",
          transition: "all 0.3s",
          borderTopRightRadius: "10px",
          borderBottomRightRadius: "10px",
          border: "1px solid #888888",
          borderLeft: "0px",
          backgroundColor: "#FAFAFA",
          width: "24px",
          minWidth:"24px",
          maxWidth: "24px",
          height:"48px",
          zIndex: "1250",
          alignItems:"center",
          cursor: "pointer",
          '&:hover': {
            backgroundColor: '#DDDDDD',
          }
      }}>
        {open ? 
        <ArrowLeft/> :  <ArrowRight/>
        }
      </Button>
  );
};

export default ClosePaneButton;
